export class AppError {
    constructor(public message: string, public params?: { token: string; str: string }[]) {}
    getMessage() {
        if (this.params) {
            let message = this.message;
            this.params.forEach((param) => {
                message = message.replace(param.token, param.str);
            });
            return message;
        }
        return this.message;
    }
}
